import React, { Component } from 'react';

class TotalStudentsBySchoolBarchart extends Component {
    constructor(props){
        super(props);
    }
    renderChart=()=>{
        const {data}=this.props;
        let schoolList=[];
        const bar={
            backgroundColor: 'rgb(245 245 245)',
            height:'20px',
            width:'100%'
        }
        const activebar={
            backgroundColor: '#f47e35',
        }
        const barlabel={
            margin:'3px 0px'
        }
        const countText={
            //position: 'absolute',
            margin: '0px 10px',
            fontSize: '14px',
            color:'#000'
        }
        schoolList=((data.data||{}).schoolSummaries||[]).sort( (a, b)=> {
            return b.count - a.count;
        });
        const maxVal=(schoolList[0]||{}).count||0;
        schoolList.forEach(itm=>{
            if(maxVal===0){
                itm.percentage=0;
            }else{
                itm.percentage=((itm.count/maxVal)*100);
            }
        })
        return (
            <div className='panel'>                                    
                <div className='panel-body'>
                    {
                        data.loading?<span className='loading text-center' style={{color:'#f47e35'}}></span>:
                        <div style={{maxHeight:'500px', 'overflowY':'scroll'}}>
                        {
                            schoolList.map((itm,i)=>{
                                return(
                                    <div>
                                        <p style={barlabel}>{itm.schoolName}</p>
                                        <div style={bar}>                                        
                                            <div style={{...activebar, width:`${itm.percentage}%`, height:'100%'}}><span style={countText}>{itm.count}</span></div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        </div>  
                    }                              
                </div>
            </div>
        );

    }


    render() {
        
        return (
            this.renderChart()
        );
    }
}

export default TotalStudentsBySchoolBarchart;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalStudentsBySchoolBarchart.jsx